export default function PHP_filesize() {
  return (
    <div>
      <h1>PHP_filesize</h1>
    </div>
  );
}
